/**
 * Query-параметры списка ключей доступа
 */

export const TAB_SIMPLE = 'simple';
export const TAB_UNIVERSAL = 'universal';

export const SIMPLE_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100, 500];
export const UNIVERSAL_PER_PAGE_OPTIONS = [5, 15, 50, 100, 500, 1000, -1];

export const DEFAULT_SIMPLE_PER_PAGE = 20;
export const DEFAULT_UNIVERSAL_PER_PAGE = 15;

function normalizePerPage (value, tab) {
  const options = tab === TAB_UNIVERSAL
    ? UNIVERSAL_PER_PAGE_OPTIONS
    : SIMPLE_PER_PAGE_OPTIONS;
  const fallback = tab === TAB_UNIVERSAL
    ? DEFAULT_UNIVERSAL_PER_PAGE
    : DEFAULT_SIMPLE_PER_PAGE;
  const parsed = parseInt(value, 10);

  if (!Number.isFinite(parsed) || !options.includes(parsed)) {
    return fallback;
  }

  return parsed;
}

export function parseAccessKeysListQuery (query = {}) {
  const tab = query.tab === TAB_UNIVERSAL ? TAB_UNIVERSAL : TAB_SIMPLE;
  const parsedPage = parseInt(query.page, 10);
  const page = Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 1;
  const perPage = normalizePerPage(query.per_page, tab);

  return {
    tab,
    page,
    perPage,
    activeTab: tab === TAB_UNIVERSAL ? 1 : 0,
  };
}

export function buildAccessKeysListQuery ({ tab, page, perPage } = {}) {
  const normalizedTab = (tab === TAB_UNIVERSAL || tab === 1) ? TAB_UNIVERSAL : TAB_SIMPLE;
  const normalizedPage = Math.max(1, parseInt(page, 10) || 1);
  const normalizedPerPage = normalizePerPage(perPage, normalizedTab);

  return {
    tab: normalizedTab,
    page: String(normalizedPage),
    per_page: String(normalizedPerPage),
  };
}

export function accessKeysListLocation (routeQuery = {}) {
  const { tab, page, perPage } = parseAccessKeysListQuery(routeQuery);
  return {
    name: 'Access-keys',
    query: buildAccessKeysListQuery({ tab, page, perPage }),
  };
}

export function accessKeyItemLocation (id, { tab, page, perPage, edit = false } = {}) {
  return {
    path: edit ? `/access-keys/${id}/edit` : `/access-keys/${id}`,
    query: buildAccessKeysListQuery({ tab, page, perPage }),
  };
}
